module.exports = __webpack_public_path__ + "img/surge.6061a181.jpg";